import { PostMethod } from '../../../serviceHelper';

const getMethods = (service: 'dm', controller: 'DocumentManagement/Objects') => ({
	GetDownloadUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDownloadUrl'
	}),
	CreateRepository: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateRepository'
	}),
	CreateFolder: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateFolder'
	}),
	GetRepositories: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetRepositories'
	}),
	GetFolderItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFolderItems'
	}),
	CopyObjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'CopyObjects'
	}),
	MoveObjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'MoveObjects'
	}),
	GetContents: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetContents'
	}),
	CreateContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateContent'
	}),
	DeleteContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteContent'
	}),
	UnsetAsDefaultContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'UnsetAsDefaultContent'
	}),
	SetAsDefaultContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'SetAsDefaultContent'
	}),
	CreateShortcut: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateShortcut'
	}),
	DeleteShortcut: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteShortcut'
	}),
	DeleteRepository: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteRepository'
	}),
	DeleteFolder: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteFolder'
	}),
	DeleteFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteFile'
	}),
	CreateFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateFile'
	}),
	GetUploadParts: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetUploadParts'
	}),
	GetObjectML: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjectML'
	}),
	RenameObject: new PostMethod<any, any>({
		service,
		controller,
		method: 'RenameObject'
	}),
	GetOfficeViewerUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetOfficeViewerUrl'
	}),
	GetVersionList: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetVersionList'
	}),
	CreateBranch: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateBranch'
	}),
	ControlCreateBranch: new PostMethod<any, any>({
		service,
		controller,
		method: 'ControlCreateBranch'
	}),
	CreateCommit: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateCommit'
	}),
	CompleteBranch: new PostMethod<any, any>({
		service,
		controller,
		method: 'CompleteBranch'
	}),
	GetVersionSuggestion: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetVersionSuggestion'
	}),
	GetCommitList: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetCommitList'
	}),
	UpdateFolderProperties: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateFolderProperties'
	}),
	GetProperties: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProperties'
	}),
	GetFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFile'
	}),
	GetFolder: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFolder'
	}),
	UpdateTags: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateTags'
	}),
	UpdateCategory: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateCategory'
	}),
	GetTags: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetTags'
	}),
	GetCategory: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetCategory'
	}),
	Subscribe: new PostMethod<any, any>({
		service,
		controller,
		method: 'Subscribe'
	}),
	Unsubscribe: new PostMethod<any, any>({
		service,
		controller,
		method: 'Unsubscribe'
	}),
	Subscriptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'Subscriptions'
	}),
	Subscription: new PostMethod<any, any>({
		service,
		controller,
		method: 'Subscription'
	}),
	DownloadMulti: new PostMethod<any, any>({
		service,
		controller,
		method: 'DownloadMulti'
	}),
	CancelBranch: new PostMethod<any, any>({
		service,
		controller,
		method: 'CancelBranch'
	}),
	GetVersionParticipators: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetVersionParticipators'
	})
});

export { getMethods };
